module.exports = __webpack_public_path__ + "static/media/home-security-icon.150e6f37.png";